/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : TRENDING NOW V2 CONFIGURATION GENERAL SECTION - SORT CONFIG : STYLES --------------- ++++++++++ */
export default theme => ({
  sortconfig: {
    '& .sortby': {
      height: pxToEm(84),
      '& .singleselectdropdown': {
        zIndex: 3
      },
    },
    // to remove the styles from dashboard .page class
    '& .page': {
      height: 'initial !important',
      display: 'block !important',
      position: 'inherit !important',
      width: 'initial !important'
    },
    '& .page.searchabledropdown': {
      width: '16.25em !important',
      display: 'flex !important',
      position: 'relative !important',
      overflow: 'unset !important',
      height: '48px !important'
    },
    '& .timeframefieldlabel': {
      display: 'flex'
    },
    '& .name-customTimeframeUnit': {
      maxWidth: pxToEm(80),
    },
    '& .previewconfig': {
      '& .content': {
        '& > div': {
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          width: pxToEm(300)
        },
        '& .articlecard': {
          width: 'calc(100% - 8px)',
          minWidth: ' calc(100% - 8px)',
          height: '165px'
        }
      }
    }
  }
});
